export default {
  state: {
    microAnimationsPlaying: []
  },
  mutations: {
    setMicroAnimation(state, payload) {
      state.microAnimationsPlaying = payload;
    },
    clearMicroAnimationsPlaying(state) {
      state.microAnimationsPlaying = [];
    }
  },
  actions: {
    findMicroAnimation({ commit, rootState, state }, id) {
      let tempArr;
      var animationFound = rootState.microAnimations.find((element) => {
        return element.id === id;
      });
      if (state.microAnimationsPlaying.length) {
        tempArr = [...state.microAnimationsPlaying, animationFound];
      } else {
        tempArr = [animationFound];
      }
      commit('setMicroAnimation', tempArr);
    },
    removeMicroAnimation({ commit, state }, id) {
      let tempArr = state.microAnimationsPlaying.filter((element) => {
        return element.id !== id;
      });
      commit('setMicroAnimation', tempArr);
    }
  }
};
